import { render, staticRenderFns } from "./PresentationTable.vue?vue&type=template&id=0da20450&scoped=true"
import script from "./PresentationTable.vue?vue&type=script&lang=js"
export * from "./PresentationTable.vue?vue&type=script&lang=js"
import style0 from "./PresentationTable.vue?vue&type=style&index=0&id=0da20450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da20450",
  null
  
)

export default component.exports